<script setup lang="ts">
import { ref } from "vue";
import { api, errorText } from "../api";
const usage = ref<any>(),
  busy = ref(false),
  error = ref("");
const count = (n: number) => n.toLocaleString("da-DK");
async function load() {
  busy.value = true;
  error.value = "";
  try {
    usage.value = await api("/api/workspace/usage");
  } catch (e) {
    error.value = errorText(e);
  } finally {
    busy.value = false;
  }
}
</script>
<template>
  <details
    class="workspace-usage"
    @toggle="($event.target as HTMLDetailsElement).open && load()"
  >
    <summary>Forbrug og rammer</summary>
    <div class="usage-body">
      <p v-if="busy && !usage" role="status">Henter forbrug…</p>
      <p v-if="error" class="error" role="alert">
        {{ error }}
        <button class="text-button" :disabled="busy" @click="load">
          Prøv igen
        </button>
      </p>
      <template v-if="usage">
        <div class="usage-heading">
          <strong>{{ usage.plan.name }}</strong
          ><button class="text-button" :disabled="busy" @click="load">
            {{ busy ? "Opdaterer…" : "Opdatér forbrug" }}
          </button>
        </div>
        <dl class="usage-values">
          <div
            v-for="(label, key) in {
              datasets: 'Datasæt',
              records: 'Gemte rækker',
            }"
            :key="key"
          >
            <dt>{{ label }}</dt>
            <dd>
              {{ count(usage.used[key])
              }}<span class="muted">{{
                usage.limits[key] === null
                  ? " · Ingen samlet grænse"
                  : " af " + count(usage.limits[key])
              }}</span>
            </dd>
            <meter
              v-if="usage.limits[key] !== null && usage.limits[key] > 0"
              min="0"
              :max="usage.limits[key]"
              :value="Math.min(usage.used[key], usage.limits[key])"
              :aria-label="
                label +
                ': ' +
                count(usage.used[key]) +
                ' af ' +
                count(usage.limits[key])
              "
            />
            <p
              v-if="
                usage.limits[key] !== null &&
                usage.used[key] >= usage.limits[key]
              "
              class="small"
            >
              Grænsen er nået.
            </p>
          </div>
        </dl>
        <p class="muted small">
          Op til {{ count(usage.limits.recordsPerDataset) }} rækker pr. datasæt.
          Arkiverede datasæt og slettede rækkeidentiteter tæller med. Et helt
          datasæt frigiver plads, når den permanente oprydning er afsluttet.
        </p>
      </template>
    </div>
  </details>
</template>
<style
  scoped
  lang="scss"
  src="../styles/components/WorkspaceUsage.scss"
></style>
